import { render, staticRenderFns } from "./CustomerCharges.vue?vue&type=template&id=e464d20a"
import script from "./CustomerCharges.vue?vue&type=script&lang=js"
export * from "./CustomerCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports